import { render, staticRenderFns } from "./crowdMember.vue?vue&type=template&id=8e350a56&"
import script from "./crowdMember.vue?vue&type=script&lang=js&"
export * from "./crowdMember.vue?vue&type=script&lang=js&"
import style0 from "./crowdMember.vue?vue&type=style&index=0&id=8e350a56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports